import { render, staticRenderFns } from "./HeaderMenuSignup.vue?vue&type=template&id=b6639212"
import script from "./HeaderMenuSignup.vue?vue&type=script&lang=js"
export * from "./HeaderMenuSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports